// import { CropFree, ZoomInMap } from "@mui/icons-material";
// import { Avatar, Grid, IconButton, Typography } from "@mui/material";
// import React, { useEffect, useRef, useState } from "react";
// import { useStyle } from "../style";
// import BillingTable from "./billingTable";
// import CustomerInfo from "./customerInfo";
// import SalesInfo from "./salesInfo";
// import { useNavigate } from "react-router-dom";
// import Logo from "../../../../../assets/images/Girlush Logo.png";
// import { Helmet } from "react-helmet-async";
// import moment from "moment";
// const Sales = () => {
//   const classes = useStyle();
//   const fullscreenRef = useRef(null);
//   const outlet_id = localStorage.getItem("outlet_id");
//   const codeRef = useRef(null);
//   const [selectedMode, setSelectedMode] = useState("cash");
//   const [reward, setReward] = useState(0);
//   const [op, setOp] = useState(false);
//   const [returnAmnt, setReturnAmnt] = useState(""); // return bill id
//   const [netTotal, setNetTotalAmnt] = useState(""); // return bill id
//   const [enableRedeem, setEnableRedeem] = useState(false);
//   const [count, setCount] = useState(0);
//   const [member, setMember] = useState(false)
//   const [subCatName, setSubCatName] = useState("");
//   const [billPoints, setBillPoints] = useState({
//     total: 0,
//     defaultPoint: 0,
//   });
//   const [poDetails, setPoDetails] = useState({
//     docDate: moment().format(),
//     salesManId: null,
//   });
//   const [thisBill, setThisBill] = useState(0);
//   const [data, setData] = useState([]);
//   const [docName, setDocName] = useState("");
//   const [docNameDefault, setDocNameDefault] = useState("");

//   const [code, setCode] = useState("");
//   const navigate = useNavigate();
//   const [postData, setPostData] = useState({
//     docdate: "",
//     amount: "",
//     subtotal_amount: "",
//     gst_per: 0,
//     gst_amt: "",
//     cess_per: 0,
//     cess_amt: "",
//     roff: "",
//     is_credit: 0,
//     salesman_id: "",
//     mode: "",
//     company_id: 1,
//     mobile: "",
//     party_name: "",
//     address: "",
//     gst_in: "",
//     outletid: outlet_id,
//     loyalty_earned: 0,
//     loyalty_redem: 0,
//     balance_points: 0,
//     return_amount: "",
//     return_billno: "",
//     outlet_sales_details: [],
//     card_amount: "",
//     cash_amount: "",
//     upi_amount: "",
//     transaction_id: "",
//     transaction_provider: 1,
//     transaction_type: 1,
//     less_amount: 0,
//     discount_amount : 0,
//   });

//   return (
//     <Grid ref={fullscreenRef} className={classes.root}>
//       <Helmet><title>Outlet Sales / Issue</title></Helmet>
//       <Grid className={classes.titleInfo} sx={{ paddingBlock: "25px" }}>
//         <Grid className="flex justify-between items-center">
//           <Avatar variant="square" src={Logo} onClick={() => navigate("/dashboard")} sx={{ cursor: "pointer" }}/>
//           <Typography fontWeight={600} ml={1} onClick={() => navigate("/dashboard")} sx={{ cursor: "pointer", fontSize: 20 }} >GIRLUSH</Typography>
//         </Grid>
//         <Typography variant="h5" fontWeight={600}>Outlet Sales</Typography>
//         <Typography>Press F11 to Full Screen </Typography>
//       </Grid>
//       <Grid className={classes.contentGrid}>
//         <Grid className="w-5/6"
//           sx={{
//             display: "flex",
//             flexDirection: "column",
//             flex: 1,
//             height: "calc(100% - 40px)",
//           }}
//         >
//           <Grid className="border-b" sx={{ height: "fit-content" }}>
//             <SalesInfo
//               setPostData={setPostData}
//               postData={postData}
//               reward={reward}
//               ref={codeRef}
//               setReward={setReward}
//               op={op}
//               data={data}
//               setOp={setOp}
//               billPoints={billPoints}
//               setBillPoints={setBillPoints}
//               setThisBill={setThisBill}
//               thisBill={thisBill}
//               setDocName={setDocName}
//               setDocNameDefault={setDocNameDefault}
//               docName={docName}
//               setReturnAmnt={setReturnAmnt}
//               returnAmnt={returnAmnt}
//               poDetails={poDetails}
//               setPoDetails={setPoDetails}
//               setEnableRedeem={setEnableRedeem}
//               enableRedeem={enableRedeem}
//               count={count}
//               subCatName={subCatName}
//               setMember={setMember}
//               selectedMode={selectedMode}
//               setSelectedMode={setSelectedMode}
//               netTotal={netTotal}
//             />
//           </Grid>
//           <Grid className="p-2 " sx={{ flex: 1 }}>
//             <BillingTable
//               data={data}
//               setData={setData}
//               code={code}
//               setCode={setCode}
//               ref={codeRef}
//               setPostData={setPostData}
//               postData={postData}
//               docName={docName}
//               poDetails={poDetails}
//               setCount={setCount}
//               setSubCatName={setSubCatName}
//             />
//           </Grid>
//         </Grid>
//         <Grid className="w-1/6 h-full border-l py-2">
//           <Grid className="border-b px-3">
//             <CustomerInfo
//               data={data}
//               postData={postData}
//               setPostData={setPostData}
//               reward={reward}
//               setReward={setReward}
//               op={op}
//               billPoints={billPoints}
//               docName={docName}
//               setBillPoints={setBillPoints}
//               setThisBill={setThisBill}
//               thisBill={thisBill}
//               setReturnAmnt={setReturnAmnt}
//               returnAmnt={returnAmnt}
//               docNameDefault={docNameDefault}
//               enableRedeem={enableRedeem}
//               member={member}
//               selectedMode={selectedMode}

//             />
//           </Grid>
//         </Grid>
//       </Grid>
//     </Grid>
//   );
// };

// export default Sales;
import { CropFree, ZoomInMap } from "@mui/icons-material";
import { Avatar, Grid, IconButton, Typography } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { useStyle } from "../style";
import BillingTable from "./billingTable";
import CustomerInfo from "./customerInfo";
import SalesInfo from "./salesInfo";
import { useNavigate } from "react-router-dom";
import Logo from "../../../../../assets/images/Girlush Logo.png";
import { Helmet } from "react-helmet-async";
import moment from "moment";
const Sales = () => {
  const classes = useStyle();
  const fullscreenRef = useRef(null);
  const outlet_id = localStorage.getItem("outlet_id");
  const codeRef = useRef(null);
  const [selectedMode, setSelectedMode] = useState("cash");
  const [reward, setReward] = useState(0);
  const [op, setOp] = useState(false);
  const [returnAmnt, setReturnAmnt] = useState(""); // return bill id
  const [netTotal, setNetTotalAmnt] = useState(""); // return bill id
  const [enableRedeem, setEnableRedeem] = useState(false);
  const [count, setCount] = useState(0);
  const [member, setMember] = useState(false);
  const [subCatName, setSubCatName] = useState("");
  const [billPoints, setBillPoints] = useState({
    total: 0,
    defaultPoint: 0,
  });
  const [poDetails, setPoDetails] = useState({
    docDate: moment().format(),
    salesManId: null,
  });
  const [thisBill, setThisBill] = useState(0);
  const [data, setData] = useState([]);
  const [docName, setDocName] = useState("");
  const [docNameDefault, setDocNameDefault] = useState("");
  const [currentTempId, setCurrentTempId] = useState(null);

  const [code, setCode] = useState("");
  const navigate = useNavigate();
  const [postData, setPostData] = useState({
    docdate: "",
    amount: "",
    subtotal_amount: "",
    gst_per: 0,
    gst_amt: "",
    cess_per: 0,
    cess_amt: "",
    roff: "",
    is_credit: 0,
    salesman_id: "",
    mode: "",
    company_id: 1,
    mobile: "",
    party_name: "",
    address: "",
    gst_in: "",
    outletid: outlet_id,
    loyalty_earned: 0,
    loyalty_redem: 0,
    balance_points: 0,
    return_amount: "",
    return_billno: "",
    outlet_sales_details: [],
    card_amount: "",
    cash_amount: "",
    upi_amount: "",
    transaction_id: "",
    utr: "",
    transaction_provider: 1,
    transaction_type: 1,
    less_amount: 0,
    discount_amount: 0,
    // referrer_mobile: null, // ✅ NEW
    referee_mobile:null,
    referee_name:"",
    s_no:"",
  });
  const IDLE_TIME = 10 * 60 * 1000; // 10 minutes
  // const IDLE_TIME = 30 * 1000;

  const idleTimerRef = useRef(null);
  const lastActivityRef = useRef(Date.now());
  const isIdleSavedRef = useRef(false);
  const customerInfoRef = useRef(null);
  const pendingDeleteRef = useRef(null);


  const handleLoadPending = async (row) => {
    try {
      // Fetch pending bill data from API using Axios
      const response = await axios.get(
        `v1/outlet_sales_pending_bill/${row.company_id}/${row.outletid}/${row.id}`
      );
      const apiData = response.data;
      //changed today
      setCurrentTempId(row.id);

      // Process product lines from API response
      const lines = (apiData.outletSalesProductDetailsTemp || []).map(
        (val) => ({
          code: val.barcode,
          barcode: val.barcode,
          qty: Number(val.qty || 0),
          mrp1: Number(val.mrp || 0),
          pro_name: val.pro_name || "",
          rate1: Number(val.rate || 0),
          gst1: Number(val.gst_per || 0),
          gst: Number(val.gst_per || 0),
          cgstPerc: Number(val.gst_per || 0),
          disc1: Number(val.dis_per || 0),
          gstAmt: Number(val.gst_amt || 0),
          cessAmt: Number(val.cess_amt || 0),
          // totalAmt: Number(val.rate || 0) * Number(val.qty || 0),
          totalAmt:val.dis_per === 100? 0: parseFloat((Number(val.rate || 0) -(Number(val.rate || 0) * Number(val.dis_per || 0)) / 100) *Number(val.qty || 0),).toFixed(2),
          id: val.prodid,
          head_id: val.head_id,
          type_id: val.type_id,
          subcat_id: val.subcat_id,
          cat_id: val.cat_id,
          uom_id: val.uom_id,
          company_id: val.company_id,
          outletid: val.outletid,
          cat_name: val.cat_name,
          hsn: val.hsn,
          cgstPerc: Number(val.gst_per || 0),
        })
      );

      setData(lines);

      // Update post data from API response
      setPostData((prev) => ({
        ...prev,
        docdate: apiData.docdate,
        amount: apiData.amount,
        subtotal_amount: apiData.subtotal_amount,
        gst_per: apiData.gst_per,
        gst_amt: apiData.gst_amt,
        cess_per: apiData.cess_per,
        cess_amt: apiData.cess_amt,
        roff: apiData.roff,
        is_credit: apiData.is_credit,
        salesman_id: apiData.salesman_id,
        mode: apiData.mode?.toLowerCase(),
        company_id: apiData.company_id,
        mobile: apiData.mobile,
        party_name: apiData.party_name,
        address: apiData.address || "",
        gst_in: apiData.gst_in,
        loyalty_redem: apiData.loyalty_redem,
        loyalty_earned: apiData.loyalty_earned,
        balance_points: apiData.balance_points,
        return_amount: 0,
        return_billno: apiData.return_billno || "",
        card_amount: apiData.card_amount,
        cash_amount: apiData.cash_amount,
        upi_amount: apiData.upi_amount,
        transaction_id: apiData.transaction_id,
        transaction_provider: apiData.transaction_provider,
        transaction_type: apiData.transaction_type,
        less_amount: apiData.less_amount,
        discount_amount: apiData.discount_amount,
        channels: apiData.channels,
        cat_name: apiData.cat_name,
        hsn: apiData.hsn,
        cgstPerc: apiData.gst_per,
        gst: apiData.gst_per,
      }));

      // Update PO details
      setPoDetails((prev) => ({
        ...prev,
        docDate: moment(apiData.docdate),
        salesManId: apiData.salesman_id
          ? { id: apiData.salesman_id, salesmanname: "" }
          : prev.salesManId,
      }));

      setNetTotalAmnt(apiData.amount);
    } catch (error) {
      console.error("Error loading pending bill:", error);
      // Optionally show user-friendly error message
    }
  };

  const handleIdleSave = () => {
    // No data → do nothing
    if (!data || data.length === 0) return;

    // Prevent multiple saves
    if (isIdleSavedRef.current) return;

    isIdleSavedRef.current = true;

    console.log("⏳ Idle detected → Auto save SAME AS NEW");

    customerInfoRef.current?.handleNew();
  };

  useEffect(() => {
    const resetIdleTimer = () => {
      lastActivityRef.current = Date.now();
    };

    const events = [
      "mousemove",
      "mousedown",
      "keydown",
      "touchstart",
      "scroll",
    ];

    events.forEach((event) => window.addEventListener(event, resetIdleTimer));

    return () => {
      events.forEach((event) =>
        window.removeEventListener(event, resetIdleTimer)
      );
    };
  }, []);

  useEffect(() => {
    idleTimerRef.current = setInterval(() => {
      const now = Date.now();
      const idleTime = now - lastActivityRef.current;

      if (idleTime >= IDLE_TIME) {
        handleIdleSave();
      }
    }, 30 * 1000); // check every 30 seconds

    return () => clearInterval(idleTimerRef.current);
  }, [data]);

  useEffect(() => {
    if (data.length === 0) {
      isIdleSavedRef.current = false;
    }
  }, [data]);

  // ✅ STEP 2: save temp id into postData
  useEffect(() => {
    if (currentTempId) {
      setPostData((prev) => ({
        ...prev,
        outlet_sales_temp_id: currentTempId,
      }));
    }
  }, [currentTempId]);

  return (
    <Grid ref={fullscreenRef} className={classes.root}>
      <Helmet>
        <title>Outlet Sales / Issue</title>
      </Helmet>
      <Grid className={classes.titleInfo} sx={{ paddingBlock: "25px" }}>
        <Grid className="flex justify-between items-center">
          <Avatar
            variant="square"
            src={Logo}
            onClick={() => navigate("/dashboard")}
            sx={{ cursor: "pointer" }}
          />
          <Typography
            fontWeight={600}
            ml={1}
            onClick={() => navigate("/dashboard")}
            sx={{ cursor: "pointer", fontSize: 20 }}
          >
            GIRLUSH
          </Typography>
        </Grid>
        <Typography variant="h5" fontWeight={600}>
          Outlet Sales
        </Typography>
        <Typography>Press F11 to Full Screen </Typography>
      </Grid>
      <Grid className={classes.contentGrid}>
        <Grid
          className="w-5/6"
          sx={{
            display: "flex",
            flexDirection: "column",
            flex: 1,
            height: "calc(100% - 40px)",
          }}
        >
          <Grid className="border-b" sx={{ height: "fit-content" }}>
            <SalesInfo
              setPostData={setPostData}
              postData={postData}
              reward={reward}
              ref={codeRef}
              setReward={setReward}
              op={op}
              data={data}
              setOp={setOp}
              billPoints={billPoints}
              setBillPoints={setBillPoints}
              setThisBill={setThisBill}
              thisBill={thisBill}
              setDocName={setDocName}
              setDocNameDefault={setDocNameDefault}
              docName={docName}
              setReturnAmnt={setReturnAmnt}
              returnAmnt={returnAmnt}
              poDetails={poDetails}
              setPoDetails={setPoDetails}
              setEnableRedeem={setEnableRedeem}
              enableRedeem={enableRedeem}
              count={count}
              subCatName={subCatName}
              setMember={setMember}
              selectedMode={selectedMode}
              setSelectedMode={setSelectedMode}
              netTotal={netTotal}
              // setCurrentTempId={setCurrentTempId}
              onLoadPending={handleLoadPending}
              onPendingDeleted={pendingDeleteRef}
            />
          </Grid>
          <Grid className="p-2 " sx={{ flex: 1 }}>
            <BillingTable
              data={data}
              setData={setData}
              code={code}
              setCode={setCode}
              ref={codeRef}
              setPostData={setPostData}
              postData={postData}
              docName={docName}
              poDetails={poDetails}
              setCount={setCount}
              setSubCatName={setSubCatName}
              outlet_id={outlet_id}
              currentTempId={currentTempId}
              onPendingDeleted={(id) => pendingDeleteRef.current?.(id)}
              setCurrentTempId={setCurrentTempId}
            />
          </Grid>
        </Grid>
        <Grid className="w-1/6 h-full border-l py-2">
          <Grid className="border-b px-3">
            <CustomerInfo
              data={data}
              postData={postData}
              setPostData={setPostData}
              reward={reward}
              setReward={setReward}
              op={op}
              billPoints={billPoints}
              docName={docName}
              setBillPoints={setBillPoints}
              setThisBill={setThisBill}
              thisBill={thisBill}
              setReturnAmnt={setReturnAmnt}
              returnAmnt={returnAmnt}
              docNameDefault={docNameDefault}
              enableRedeem={enableRedeem}
              member={member}
              selectedMode={selectedMode}
              currentTempId={currentTempId}
              ref={customerInfoRef}
            />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Sales;
